import React, { useCallback, useContext, useEffect, useMemo, useRef } from 'react'
import { Col, Row, Card, Form, Container, Button, InputGroup } from '@themesberg/react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCalendarAlt } from '@fortawesome/free-solid-svg-icons'
import Datetime from "react-datetime";
import moment from "moment-timezone";
import { Context } from '..'

const _FilterForm = () => {

  const { state, dispatch } = useContext(Context);

  const _from = useRef(state.filter.from);
  const _to = useRef(state.filter.to);
  const _identify = useRef(state.filter.identify);
  const _cartId = useRef(state.filter.cartId);
  const _id = useRef(state.filter.id);
  const _status = useRef(state.filter.status);
  const _routeId = useRef(state.filter.routeId);

  const _handleChangeFrom = useCallback((payload) => {
    _from.current = payload
  }, [])

  const _handleChangeTo = useCallback((payload) => {
    _to.current = payload
  }, [])

  const _handleChangeIdentify = useCallback((payload) => {
    _identify.current = payload.target.value
  }, [])

  const _handleChangeCartId = useCallback((payload) => {
    _cartId.current = payload.target.value
  }, [])

  const _handleChangeId = useCallback((payload) => {
    _id.current = payload.target.value
  }, [])

  const _handleChangeStatus = useCallback((payload) => {
    _status.current = payload.target.value
  }, [])

  const _handleChangeRouteId = useCallback((payload) => {
    _routeId.current = payload.target.value
  }, [])

  const _submitForm = useCallback(() => {
    dispatch({
      type: 'SUBMIT_FILTER',
      payload: {
        from: _from.current,
        to: _to.current,
        identify: _identify.current,
        id: _id.current,
        cartId: _cartId.current,
        status: _status.current,
        routeId: _routeId.current,
      }
    })
  }, [dispatch])

  const _changeFilterMethod = useCallback((method) => {
    dispatch({
      type: 'CHANGE_FILTER_METHOD',
      payload: {
        method: method
      }
    })
  }, [dispatch])

  useEffect(() => {
    _cartId.current = state.filter.cartId
  }, [state.filter.cartId])

  return (
    <>
      <Card border="light" className="shadow-sm">
        <Card.Header>
          <Row className="align-items-center">
            <Col className='align-self-center'>
              <h5>Vé tàu</h5>
            </Col>
            <Col className='text-left'>
              <Button
                style={{ marginRight: 20 }}
                variant="primary"
                disabled={state.filter.method === 'BY_ID'}
                type="submit"
                onClick={() => _changeFilterMethod('BY_ID')}>
                Tìm theo mã vé
              </Button>
            </Col>
            <Col className='text-left'>
              <Button
                style={{ marginRight: 20 }}
                variant="success"
                disabled={state.filter.method === 'BY_CART_ID'}
                type="submit"
                onClick={() => _changeFilterMethod('BY_CART_ID')}>
                Tìm theo mã đơn
              </Button>
            </Col>
            <Col className='text-left'>
              <Button
                style={{ marginRight: 20 }}
                variant="warning"
                disabled={state.filter.method === 'BY_CONDITION'}
                type="submit"
                onClick={() => _changeFilterMethod('BY_CONDITION')}>
                Tìm theo điều kiện
              </Button>
            </Col>
            <Col className='text-right'>
              <Button style={{ marginRight: 20 }} variant="info" type="submit" onClick={_submitForm}>Tìm kiếm</Button>
            </Col>
          </Row>
        </Card.Header>
        {state.filter.method === 'BY_CONDITION' ?
          <Card.Body>
            <Container>
              <Col>
                <Row className='p-1'>
                  <Col sm={12} md={6}>
                    <Row>
                      <Col md={3} className='text-left align-self-center'>
                        <Form.Label>Từ ngày</Form.Label>
                      </Col>
                      <Col md={9}>
                        <Datetime
                          dateFormat="DD/MM/YYYY"
                          timeFormat={false}
                          initialValue={_from.current ? moment(_from.current).format("DD/MM/YYYY") : ""}
                          onChange={_handleChangeFrom}
                          renderInput={(props, openCalendar) => (
                            <InputGroup>
                              <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
                              <Form.Control
                                required
                                type="text"
                                value={_from.current ? moment(_from.current).format("DD/MM/YYYY") : ""}
                                placeholder="dd/mm/yyyy"
                                onFocus={openCalendar}
                                onChange={() => { }} />
                            </InputGroup>
                          )}
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col sm={12} md={6}>
                    <Row>
                      <Col md={3} className='text-left align-self-center'>
                        <Form.Label>Đến ngày</Form.Label>
                      </Col>
                      <Col md={9}>
                        <Datetime
                          timeFormat={false}
                          onChange={_handleChangeTo}
                          renderInput={(props, openCalendar) => (
                            <InputGroup>
                              <InputGroup.Text><FontAwesomeIcon icon={faCalendarAlt} /></InputGroup.Text>
                              <Form.Control
                                required
                                type="text"
                                value={_to.current ? moment(_to.current).format("DD/MM/YYYY") : ""}
                                placeholder="dd/mm/yyyy"
                                onFocus={openCalendar}
                                onChange={() => { }} />
                            </InputGroup>
                          )}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row className='p-1'>
                  <Col sm={12} md={6}>
                    <Row>
                      <Col md={3} className='text-left align-self-center'>
                        <Form.Label>CMND/CCCD</Form.Label>
                      </Col>
                      <Col md={9}>
                        <Form.Control onChange={_handleChangeIdentify} required type="text" placeholder="Nhập CMND/CCCD" />
                      </Col>
                    </Row>
                  </Col>
                  <Col sm={12} md={6}>
                    <Row>
                      <Col md={3} className='text-left align-self-center'>
                        <Form.Label>Tuyến</Form.Label>
                      </Col>
                      <Col md={9}>
                        <Form.Select onChange={_handleChangeRouteId}>
                          <option defaultValue value={''}>Tất cả</option>
                          {state.filterCondition.listRoute.map(i => {
                            return <option key={i.id + '-route'} value={i.id}>{i.name}</option>
                          })}
                        </Form.Select>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row className='p-1'>
                  <Col sm={12} md={6}>
                    <Row>
                      <Col md={3} className='text-left align-self-center'>
                        <Form.Label>Trạng thái</Form.Label>
                      </Col>
                      <Col md={9}>
                        <Form.Select onChange={_handleChangeStatus}>
                          <option defaultValue value={''}>Tất cả</option>
                          <option value={'1'}>Đang chờ</option>
                          <option value={'2'}>Xong</option>
                          <option value={'3'}>Đã hủy</option>
                        </Form.Select>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
            </Container>
          </Card.Body>
          : state.filter.method === 'BY_ID' ?
            <Card.Body>
              <Container>
                <Col>
                  <Row className='p-1'>
                    <Col sm={12} md={6}>
                      <Row>
                        <Col md={3} className='text-left align-self-center'>
                          <Form.Label>{'Mã vé'}</Form.Label>
                        </Col>
                        <Col md={9}>
                          <Form.Control onChange={_handleChangeId} required type="text" placeholder="Nhập mã vé" />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Container>
            </Card.Body>
            :
            <Card.Body>
              <Container>
                <Col>
                  <Row className='p-1'>
                    <Col sm={12} md={6}>
                      <Row>
                        <Col md={3} className='text-left align-self-center'>
                          <Form.Label>{'Mã đơn'}</Form.Label>
                        </Col>
                        <Col md={9}>
                          <Form.Control defaultValue={state.filter.cartId} onChange={_handleChangeCartId} required type="text" placeholder="Nhập mã đơn" />
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </Container>
            </Card.Body>
        }
      </Card>
    </>
  );
};

export default React.memo(_FilterForm)